// extracted by mini-css-extract-plugin
export var bubble = "_2q-0";
export var container = "_2q-f";
export var contrastBorder = "_2q-g";
export var greyOut = "_2q-2";
export var initialsColor0 = "_2q-3";
export var initialsColor1 = "_2q-4";
export var initialsColor10 = "_2q-d";
export var initialsColor11 = "_2q-e";
export var initialsColor2 = "_2q-5";
export var initialsColor3 = "_2q-6";
export var initialsColor4 = "_2q-7";
export var initialsColor5 = "_2q-8";
export var initialsColor6 = "_2q-9";
export var initialsColor7 = "_2q-a";
export var initialsColor8 = "_2q-b";
export var initialsColor9 = "_2q-c";
export var initialsWrapper = "_2q-1";
export var large = "_2q-l";
export var medium = "_2q-k";
export var mediumSmall = "_2q-j";
export var mediumSmallMedium = "_2q-o";
export var micro = "_2q-h";
export var small = "_2q-i";
export var tiny = "_2q-n";
export var xTiny = "_2q-m";